import "../SpaceCard/SpaceCard.scss";
import { Component } from "react";
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer } from 'recharts';
import { appContext } from "../../../AppContext";
import IbssButtonRedo from "../../Buttons/Button/IbssButton";
import { constTotal, defaultAny, defaultNodeLevel, defaultMetabookable } from "../../../app/constants";
import { Link } from "react-router-dom";
import { DateTime } from 'luxon';
import { ChartPanelInfo } from "../../Headings/ChartHeading/ChartPanelInfo";
import { rights } from "../../../Common/RightsManager";

class SpaceAnalyticsCard extends Component<Props, State>
{
    private labels = appContext().labels;
    constructor(props: Props)
    {
        super(props);
        this.state = new State();
    };

    Item = styled(Paper)(({ theme }) => ({
        backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
        ...theme.typography.body2,
        padding: theme.spacing(1),
        textAlign: 'center',
        color: theme.palette.text.secondary,
    }));

    public componentDidMount(): void
    {
        if (rights.ONELENS360.SpaceAnalytics.Analytics.has())
        {
            this.setState({
                viewAllButtons: true
            })
        }
    }

    public render(): JSX.Element
    {
        const tempretatureInfo =
            [
                { space: `${this.props.periodCurrentSpaceValue.toFixed(2)}`, label: `${this.labels.HubLabelSpaces}`, name: "" },
                { capacity: `${this.props.periodCurrentCapacityValue.toFixed(2)}`, label: `${this.labels.HubLabelCapacity}`, name: "" },
                { peak: `${this.props.periodCurrentPeakValue.toFixed(2)}`, label: `${this.labels.HublabelPeak}`, name: "" }
            ];
        const state = {
            buildingNodeId: this?.props?.buildingNodeId,
            buildingname: this?.props?.buildingName,
            classtype: this?.props?.spaceClass,
            startdate: DateTime.fromJSDate(new Date(this.props.startDate)).toISO(),
            enddate: DateTime.fromJSDate(new Date(this.props.endDate)).toISO(),
            floortype: defaultAny,
            workspaceType: constTotal,
            groupby: defaultNodeLevel,
            metabookable: +defaultMetabookable
        }
        return (
            <>
                <Grid item md={4} xs={12}>
                    <div className="ibss-card">
                        <div className="ibss-card-header">
                            <ChartPanelInfo
                                chartHeading={`${
                                    this?.props?.spaceClass === "Work"
                                    ? this.labels.HublabelWork
                                    : this?.props?.spaceClass === "Support"
                                    ? this.labels.HublabelSupport
                                    : this?.props?.spaceClass === "Amenity"
                                        ? this.labels.HublabelAmenity
                                        : ""
                                    } ${this.labels.HublabelSpaceClassification}`}
                            />
                        </div>
                        <div className="ibss-card-body">
                            <div className="">
                                <ResponsiveContainer width={"100%"} height={200}>
                                    <BarChart
                                        data={tempretatureInfo}
                                        height={200}
                                        width={400}
                                        margin={{
                                            top: 20,
                                            right: 30,
                                            left: 20,
                                            bottom: 5,
                                        }}
                                    >
                                        <XAxis stroke="var(--ui-text)" dataKey="name" />
                                        <YAxis stroke="var(--ui-text)" unit="%" />
                                        <Tooltip
                                            contentStyle={{
                                                color: "var(--ui-text)",
                                                backgroundColor: "var(--ui-background-alternate)",
                                            }}
                                        />
                                        {/* Bar graph division */}
                                        <Bar
                                            dataKey="space"
                                            name={this.labels.HubLabelSpace}
                                            stackId="a"
                                            fill="#4584ff"
                                        />
                                        <Bar
                                            dataKey="capacity"
                                            name={this.labels.HubLabelCapacity}
                                            stackId="a"
                                            fill="#6cc1a7"
                                        />
                                        <Bar
                                            dataKey="peak"
                                            name={this.labels.HublabelPeak}
                                            stackId="a"
                                            fill="#ea754b"
                                        />
                                        <Bar
                                            dataKey="NoData"
                                            name={this.labels.HubLabelNoData}
                                            stackId="a"
                                            fill="#393D44"
                                        />
                                    </BarChart>
                                </ResponsiveContainer>
                                <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                                    <Grid item xs={5}>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <h2 className="text-ui-20 my-0" >
                                            {this.labels.HubLabelUtilization}
                                        </h2>
                                    </Grid>
                                    <Grid item xs={1}>
                                    </Grid>
                                </Grid>
                            </div>
                            <table className="w-100">
                                <tbody>
                                    <tr>
                                        <td>
                                            <div
                                                className="statusbox my-8"
                                                style={{ backgroundColor: "#4584ff" }}
                                            ></div>
                                        </td>
                                        <td>
                                            <p className="barchart-data-labels my-8">
                                                {this.labels.HublabelSpaceUtilization}
                                            </p>
                                        </td>
                                        <td>
                                            <p className="barchart-data-labels text-right my-8">
                                                {Math.round(this.props.periodCurrentSpaceValue)}%
                                            </p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div
                                                className="statusbox my-8"
                                                style={{ backgroundColor: "#6cc1a7" }}
                                            ></div>
                                        </td>
                                        <td>
                                            <p className="barchart-data-labels my-8">
                                                {this.labels.HublabelCapacityUtilization}
                                            </p>
                                        </td>
                                        <td>
                                            <p className="barchart-data-labels text-right my-8">
                                                {Math.round(
                                                    this.props.periodCurrentCapacityValue
                                                )}
                                                %
                                            </p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div
                                                className="statusbox my-8"
                                                style={{ backgroundColor: "#ea754b" }}
                                            ></div>
                                        </td>
                                        <td>
                                            <p className="barchart-data-labels my-8">
                                                {this.labels.HublabelPeakUtilization}
                                            </p>
                                        </td>
                                        <td>
                                            <p className="barchart-data-labels text-right my-8">
                                                {Math.round(this.props.periodCurrentPeakValue)}%
                                            </p>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            {this.state.viewAllButtons === true &&
                                <Link
                                    to={{
                                        pathname: "/space-analytics-analytics",
                                        state: { ...state },
                                    }}
                                    className="text-decoration-none">
                                    <div className="d-flex justify-content-center">
                                        <IbssButtonRedo
                                            variant='contained'
                                        >
                                            {" "}
                                            {this.labels.HublabelViewAll} {this?.props?.spaceClass}{" "}
                                            {this.labels.HubLabelSpaces}
                                        </IbssButtonRedo>
                                    </div>
                                </Link>
                            }
                        </div>
                    </div>
                </Grid>
            </>
        );
    }
};

export default SpaceAnalyticsCard;
export class Props
{
    spaceClass: string = "";
    periodCurrentPeakValue: number = 0;
    periodCurrentCapacityValue: number = 0;
    periodCurrentSpaceValue: number = 0;
    periodType: number = 0;
    startDate: string = "";
    endDate: string = "";
    buildingNodeId: number = 0;
    buildingName: string = "";
}

export class State
{
    public viewAllButtons: boolean = false
}
